import { render, staticRenderFns } from "./MarketData.vue?vue&type=template&id=62e584bf&scoped=true"
import script from "./MarketData.vue?vue&type=script&lang=js"
export * from "./MarketData.vue?vue&type=script&lang=js"
import style0 from "./MarketData.vue?vue&type=style&index=0&id=62e584bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e584bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
